import { useState } from "react";
import Pagination from "../../../components/pagination";
import { Button } from "../../../components/ui";
import useSelectTemplateForUserSalary from "../../../hooks/salary/useSelectTemplateForUserSalary";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { checkIfEmpty } from "../../../utility";
import toast from "react-hot-toast";
import { constructSearchParamsFromObject } from "../../../utility/utils";
import BreadCrumbs from "../../../components/ui/BreadCrumbs";

const SelectTemplateForUserSalary = () => {
  const navigate = useNavigate();
  const { id, username } = useParams();
  const [searchParams] = useSearchParams();
  const source = searchParams.get("source");

  const breadcrumbs = [
    {
      label: "Salary Details",
      link: `/employee-salary-details/${id}/${username}?source=${source}`,
    },
    { label: "Select Salary Template" },
  ];

  const paramsObj = {};
  for (const [key, value] of searchParams.entries()) {
    paramsObj[key] = value;
  }

  const {
    templatesList,
    pagination,
    isTemplateListLoading,
    handlePageClick,
    handleSearch,
  } = useSelectTemplateForUserSalary();

  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const moveToNextStep = () => {
    if (checkIfEmpty(selectedTemplate)) {
      console.log("IN HERE");
      toast.error('Please select a template to proceed, or click on "Add new"');
      return;
    }

    const searchStr = constructSearchParamsFromObject({
      ...paramsObj,
      templateId: selectedTemplate.template_id,
    });

    navigate(`/employee-salary/${id}/${username}/add-salary${searchStr}`);
  };

  const addNewSalaryDetails = () => {
    const searchStr = constructSearchParamsFromObject(paramsObj);

    navigate(`/employee-salary/${id}/${username}/add-salary${searchStr}`);
  };

  return (
    <div>
      <div className="p-4 flex justify-between sticky bg-white top-16 shadow-lg">
        <h2 className="font-semibold text-2xl">
          Add Employee Salary Details for "{username}"
        </h2>

        <Button onClick={moveToNextStep} className={"hover:opacity-80"}>
          Move to next step
        </Button>
      </div>
      <div className="px-4 my-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-3 mt-5">
          <div></div>
          <button
            onClick={addNewSalaryDetails}
            className="border border-neutral-300 p-5 rounded-md space-y-4 hover:bg-slate-50"
          >
            <p className="text-lg font-semibold">Add New</p>
          </button>
          <div></div>
        </div>

        <div className="flex space-x-4 items-center mt-6">
          <hr className="grow border-t-2 border-neutral-200" />
          <p className="font-medium">OR</p>
          <hr className="grow border-t-2 border-neutral-200" />
        </div>

        <p className="mt-6 w-full text-center font-semibold text-xl">
          Choose from a template
        </p>
        <p className="text-neutral-400 text-center">Click to select</p>

        <input
          type="text"
          className="border border-neutral-300 px-2 py-1.5 w-80 mt-4 rounded-md mx-auto block "
          onChange={handleSearch}
          placeholder="Search template by name"
        />

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          {templatesList?.map((template) => {
            const { name, annual_ctc } = template;
            return (
              <button
                key={template.template_id}
                onClick={() => {
                  setSelectedTemplate(template);
                }}
                className={
                  "border border-neutral-300 p-5 rounded-md space-y-4 hover:bg-slate-50 " +
                  (selectedTemplate?.template_id === template.template_id
                    ? "bg-blue-100"
                    : "")
                }
              >
                <p className="text-lg font-semibold">{name}</p>
                <p className="text-sm">Annual CTC: &#8377; {annual_ctc}</p>
              </button>
            );
          })}
        </div>

        {isTemplateListLoading && (
          <div className="w-full flex justify-center items-center py-40">
            <div className="loader"></div>
            <p className="ml-6">Loading...</p>
          </div>
        )}

        <div className="grid w-full place-items-center mt-6">
          <Pagination
            currentPage={pagination.current_page_number}
            lengthofItems={+pagination.total_count}
            limit={pagination.per_page_limit}
            onPageChange={handlePageClick}
          />

          <Button
            onClick={moveToNextStep}
            className={" mt-16 hover:opacity-80"}
          >
            Move to next step
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectTemplateForUserSalary;
